import React, { useState, useEffect, useCallback } from 'react';
import debounce from 'lodash/debounce';
// components
import SearchInput from 'shared/inputs/SearchInput';
import Select from 'shared/inputs/Select';

const LocationsToolbar = ({
  locationTypes,
  restrictedTypes,
  handleSearch,
  reset,
  isLoading,
  initialValues,
}) => {
  // track if we have searched so we don't double load
  const [hasSearched, setHasSearched] = useState(false);

  // search and filter
  const [search, setSearch] = useState(initialValues?.name ?? '');
  const [types, setTypes] = useState(
    restrictedTypes && restrictedTypes.length ? restrictedTypes.map(x => ({ label: x.description, value: x.text })) : []
  );

  const searchCallback = useCallback(
    debounce(async (searchString, typesSearch) => {
      handleSearch({ Name: searchString, Type: typesSearch.map(x => x.value) });
    }, 500),
    []
  );

  // Trigger anytime the types values changes. No need to trigger
  // for search since we want that to be manual.
  useEffect(() => {
    if (isLoading) {
      return;
    }
    // If we have searched then we will listen to this call and searchCallback regardless of values.
    // If we haven't searched then don't do anything until a user enters/changes a value.
    if (hasSearched || search || types.length > 0) {
      setHasSearched(true);
      searchCallback(search, types);
    }
  }, [types]);

  // reset functionality
  useEffect(() => {
    if (reset) {
      setSearch('');
      // don't clear this if restricted (location picker)
      if (!restrictedTypes || !restrictedTypes.length) {
        setTypes([]);
      }
    }
  }, [reset]);

  return (
    <React.Fragment>
      <div className='toolbar--column flex toolbar--margin'>
        <div className='filter-wrapper'>
          <label className='label'>Search Name</label>
          <SearchInput
            value={search}
            onChange={({ target: { value } }) => setSearch(value)}
            onSearch={val => searchCallback(val, types)}
            disabled={isLoading}
          />
        </div>
      </div>
      <div className='toolbar--column flex toolbar--margin'>
        <div className='filter-wrapper small'>
          <label className='label'>Location Types</label>
          <Select
            isMulti
            hideSelectedOptions={false}
            closeMenuOnSelect={false}
            className='select'
            value={types}
            onChange={selectedOption => setTypes(selectedOption)}
            options={locationTypes.map(x => ({ label: x.description, value: x.text }))}
            disabled={restrictedTypes || isLoading}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default LocationsToolbar;
